import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";
import { Client } from "./API/client";
import { toastrService } from "./ux/toastr.service";

@Injectable()
export class NotificationCountService {
  // servisi merr count e notifications dhe ben share count te nav dhe profile/notifications

  private countSource = new BehaviorSubject<number>(0);
  count = this.countSource.asObservable();

  constructor(private api: Client, private toastr: toastrService) {}

  public getNotificationCount() {
    this.api
      .get("api/notifications")
      .then((res: any[]) => {
        // change default value of countSource me numrin e notifikimeve
        const unseenNotif = res.filter((notif) => notif.IsSeen === false);
        this.countSource.next(unseenNotif.length);
      })
      .catch((err) => {
        this.toastr.error(err);
      });
  }

  // ndrysho countin e notifikimeve
  updateCount(count: number) {
    this.countSource.next(count);
  }
}
